/**
 * The viewer's clock — V98-3 review R3-S10.
 *
 * Time-of-day UI ("Signed today", "Undo · N h left") reads the clock and the
 * viewer's time zone from here, so tests (and the fixtures harness) can pin
 * both instead of depending on the machine's wall clock and zone — the
 * "signed today" tests failed just after local midnight. The app uses the
 * default: the real clock and the browser's own time zone.
 */
import { createContext, useContext } from 'react';

export interface Clock {
  /** Epoch milliseconds now. */
  now: () => number;
  /** IANA zone for "today" / stamps; undefined = the viewer's own (browser) zone. */
  timeZone?: string;
}

export const ClockContext = createContext<Clock>({ now: () => Date.now() });
export const useClock = (): Clock => useContext(ClockContext);
